import React from "react";
import { IconSearch } from "@tabler/icons-react";
import clsx from "clsx";

export default function SearchField(props: {
  placeholder: string;
  onClick: () => void;
  hasError?: boolean;
  labelName?: string;
  helper?: React.ReactNode;
  containerClassName?: string;
  required?: boolean;
}) {
  return (
    <div className={props.containerClassName}>
      <label htmlFor="email" className="block text-sm text-gray-700">
        {props.labelName}
        {props.required && <span>*</span>}
      </label>
      <div
        className={clsx(
          "w-full border border-gray-300 h-9 rounded-md items-center flex",
          "justify-between px-2 text-gray-500 cursor-pointer whitespace-nowrap",
          { "border-red-700": props.hasError }
        )}
        onClick={props.onClick}
      >
        <span
          className={clsx("text-sm text-gray-500 pr-1 truncate", {
            "text-red-400": props.hasError,
          })}
        >
          {props.placeholder}
        </span>
        <IconSearch
          className={clsx({
            "text-red-600 min-w-6 min-h-6": props.hasError,
          })}
        />
      </div>
      {props?.helper && (
        <div
          className={clsx("text-sm leading-5 font-normal mt-2 text-gray-500")}
        >
          {props.helper}
        </div>
      )}
    </div>
  );
}
